import * as Scrivito from "scrivito"

export const FinalCallToActionWidget = Scrivito.provideWidgetClass(
  "FinalCallToActionWidget",
  {
    attributes: {
      title: ["widgetlist", { only: "TextWidget", maximum: 1 }],
      subtitle: ["widgetlist", { only: "TextWidget", maximum: 1 }],
      button: ["widgetlist", { only: ["ButtonWidget", "LoginButtonWidget"] }],
      lightImage: ["reference", { only: "Image" }],
      darkImage: ["reference", { only: "Image" }]
    }
  }
)
